import React, { useState } from 'react'
import { useGoogleTranslate } from '../../../Hooks/useGoogleTranslate'
import { Col, Container, Row } from 'react-bootstrap'
import boostYourProfileIcon from '../../../assets/images/boost-icon.png'
import becomeAnAffiliateIcon from '../../../assets/images/affiliate-icon.png'
import whoCanViewMyProfileIcon from '../../../assets/images/view-profile-icon.png'
import messageControlIcon from '../../../assets/images/message-control-icon.png'
import verifyYourProfileIcon from '../../../assets/images/verify-profile-icon.png'
import helpCenterIcon from '../../../assets/images/help-center-icon.png'
import { Link } from 'react-router-dom'
import './index.css'
import CustomButton from '../../../Components/CustomButton'
import DeactivateAccountModal from '../../../Components/DeactivateAccountModal/DeactivateAccountModal'
import DeleteAccountModal from '../../../Components/DeleteAccountModal/DeleteAccountModal'
import BoostProfileModal from '../../../Components/BoostProfileModal/BoostProfileModal'
import HideProfileModal from '../../../Components/HideProfileModal/HideProfileModal'
import MessageControlModal from '../../../Components/MessageControlModal/MessageControlModal'
import VerifyProfileInfoModal from '../../../Components/VerifyProfileInfoModal/VerifyProfileInfoModal'
import VerifyProfileModal from '../../../Components/VerifyProfileModal/VerifyProfileModal'
import LogoutModal from '../../../Components/LogoutModal/LogoutModal'
import { useLogout } from '../../../Hooks/useLogout'
import useUserStore from '../../../Stores/UserStore'
import { showToast } from '../../../Components/Toast/toast'
import { useNavigate } from 'react-router-dom'
import heartDecor from '../../../assets/images/coin-store-figma/decor-heart.svg'
import { getIsUserSubscribedFromLogs, getUserSubscriptionLogs } from '../../../Services/User/UserSubscriptionService'

const Settings = () => {
    const pageTitle = useGoogleTranslate('Settings');
    const boostProfile = useGoogleTranslate('Boost your profile');
    const becomeAffiliate = useGoogleTranslate('Become an Affiliate');
    const whoCanView = useGoogleTranslate('Who can view my profile?');
    const messageControl = useGoogleTranslate('Message Control');
    const verifyProfile = useGoogleTranslate('Verify your profile');
    const helpCenter = useGoogleTranslate('Help Center');
    const deleteAccount = useGoogleTranslate('Delete My Account');
    const deactivateAccount = useGoogleTranslate('Deactivate My Account');
    const logoutLabel = useGoogleTranslate('Logout');
    const { role = 'user' } = useUserStore()
    const navigate = useNavigate()
    const [showDeactivateModal, setShowDeactivateModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [showBoostProfileModal, setShowBoostProfileModal] = useState(false)
    const [showHideProfileModal, setShowHideProfileModal] = useState(false)
    const [showMessageControlModal, setShowMessageControlModal] = useState(false)
    const [showVerifyProfileInfoModal, setShowVerifyProfileInfoModal] = useState(false)
    const [showVerifyProfileModal, setShowVerifyProfileModal] = useState(false)
    const [showLogoutModal, setShowLogoutModal] = useState(false)
    const logoutMutation = useLogout()

    const handleLogoutClick = () => {
        setShowLogoutModal(true)
    }

    const handleLogout = () => {
        logoutMutation.mutate(role)
        setShowLogoutModal(false)
    }

    const handlePremiumFeatureAccess = async (onGranted, upgradeMessage) => {
        try {
            const response = await getUserSubscriptionLogs()
            const isSubscribed = getIsUserSubscribedFromLogs(response)

            if (isSubscribed) {
                onGranted()
                return
            }
        } catch (error) {
            // Fallback to store premium state if live check fails
            const isPremiumFromStore = useUserStore.getState().isPremium()
            if (isPremiumFromStore) {
                onGranted()
                return
            }
        }

        showToast(upgradeMessage, 'error')
        navigate('/subscription-plans')
    }
    return (
        <>
            <section className="settings-figma-page">
                <img src={heartDecor} alt="" className="settings-figma-heart" aria-hidden="true" />
                <div className="settings-figma-hero">
                    <Container>
                        <h1 className="settings-figma-title">{pageTitle}</h1>
                    </Container>
                </div>
                <div className="settings-figma-main py-sm-5 py-4">
                <Container className="settings-figma-container">
                    <Row className='justify-content-center'>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowBoostProfileModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>{boostProfile}</h6>
                                    <img src={boostYourProfileIcon} alt="Boost your profile" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div
                                className='d-block text-decoration-none h-100'
                                onClick={() => navigate('/affiliate')}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>{becomeAffiliate}</h6>
                                    <img src={becomeAnAffiliateIcon} alt="Become an Affiliate" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div
                                className='d-block text-decoration-none h-100'
                                onClick={async () => {
                                    await handlePremiumFeatureAccess(
                                        () => setShowHideProfileModal(true),
                                        'Please upgrade to Premium to manage profile visibility'
                                    )
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>{whoCanView}</h6>
                                    <img src={whoCanViewMyProfileIcon} alt="Who can view my profile?" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div
                                className='d-block text-decoration-none h-100'
                                onClick={async () => {
                                    await handlePremiumFeatureAccess(
                                        () => setShowMessageControlModal(true),
                                        'Please upgrade to Premium to control message reception'
                                    )
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>{messageControl}</h6>
                                    <img src={messageControlIcon} alt="Message Control" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowVerifyProfileInfoModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>{verifyProfile}</h6>
                                    <img src={verifyYourProfileIcon} alt="Verify your profile" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <Link to={'/help-center'} className='d-block text-decoration-none h-100'>
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>{helpCenter}</h6>
                                    <img src={helpCenterIcon} alt="Help Center" className="img-fluid mx-auto" />
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className='settings-actions-wrap'>
                            <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center settings-actions">
                                <CustomButton
                                    className="secondaryButton settings-outline-btn"
                                    text={deactivateAccount}
                                    onClick={() => setShowDeactivateModal(true)}
                                />
                                <CustomButton
                                    className="secondaryButton settings-outline-btn"
                                    text={deleteAccount}
                                    onClick={() => setShowDeleteModal(true)}
                                />
                                <CustomButton
                                    className="settings-logout-btn"
                                    text={logoutLabel}
                                    onClick={handleLogoutClick}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
                </div>
            </section>

            {/* Deactivate Account Modal */}
            <DeactivateAccountModal
                show={showDeactivateModal}
                onHide={() => setShowDeactivateModal(false)}
            />

            {/* Delete Account Modal */}
            <DeleteAccountModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
            />

            {/* Boost Profile Modal */}
            <BoostProfileModal
                show={showBoostProfileModal}
                onHide={() => setShowBoostProfileModal(false)}
            />

            {/* Hide Profile Modal */}
            <HideProfileModal
                show={showHideProfileModal}
                onHide={() => setShowHideProfileModal(false)}
            />

            {/* Message Control Modal */}
            <MessageControlModal
                show={showMessageControlModal}
                onHide={() => setShowMessageControlModal(false)}
            />

            {/* Verify Profile Info Modal */}
            <VerifyProfileInfoModal
                show={showVerifyProfileInfoModal}
                onHide={() => setShowVerifyProfileInfoModal(false)}
                onVerifyNow={() => {
                    setShowVerifyProfileInfoModal(false);
                    setShowVerifyProfileModal(true);
                }}
            />

            {/* Verify Profile Modal */}
            <VerifyProfileModal
                show={showVerifyProfileModal}
                onHide={() => setShowVerifyProfileModal(false)}
            />

            {/* Logout Modal */}
            <LogoutModal
                show={showLogoutModal}
                onClose={() => setShowLogoutModal(false)}
                onLogout={handleLogout}
                isLoading={logoutMutation.isPending}
            />
        </>
    )
}

export default Settings
